import { Box, makeStyles, Typography } from "@material-ui/core";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import clsx from "clsx";
import React, { ChangeEvent, FC, useContext, useRef } from "react";

import useCurrentUser from "../../../../../hooks/useCurrentUser";
import { AppResource } from "../../../../../types/resource.types";
import { handleLocalFileEntries } from "../../../../../utils/fileUpload";
import { ILocalFileEntry } from "../types";
import { ImageUploaderContext } from "./ImageUploaderContainer";

const useStyles = makeStyles(() => ({
  uploader: {
    height: 100,
    position: "relative",
    border: "1px solid #ccc",
    cursor: "pointer",

    "&.disabled": {
      pointerEvents: "none",
      opacity: 0.5,
    },

    "& .upload-icon-container": {
      zIndex: 5,
      position: "absolute",
      width: "100%",
      height: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",

      "& .upload-icon-with-text-container": {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
      },
    },

    "& input": {
      backgroundColor: "purple",
      width: "100%",
      height: "100%",
      padding: 8,
      opacity: 0,
      zIndex: 10,
      position: "absolute",
    },
  },
  uploadIcon: {
    fontSize: 60,
    color: "#878787",
  },
}));

const ImageUploaderInput: FC<ImageUploaderInputProps> = ({ onSelectFiles }) => {
  const classes = useStyles({});

  const { uploadLoading } = useContext(ImageUploaderContext);
  const inputRef = useRef<any>(null);
  const { user } = useCurrentUser();

  const handleSelectFiles = (e: ChangeEvent<HTMLInputElement>) => {
    const localFilesEntry = handleLocalFileEntries(
      e.target.files,
      `${AppResource.brands}/${user.id}/${AppResource.brandsMedia}`
    );
    onSelectFiles(localFilesEntry);
    e.target.value = "";
  };

  return (
    <Box className={clsx([classes.uploader, { disabled: uploadLoading }])}>
      <Box className="upload-icon-container">
        <Box className="upload-icon-with-text-container">
          <CloudUploadIcon className={classes.uploadIcon} />
          <Typography color="textSecondary">Click to upload or drag images here</Typography>
        </Box>
      </Box>
      <input type="file" multiple accept="image/*" id="upload-image" ref={inputRef} onChange={handleSelectFiles} />
    </Box>
  );
};

interface ImageUploaderInputProps {
  onSelectFiles: (localFilesEntry: ILocalFileEntry[]) => void;
}

export default ImageUploaderInput;
